// @ts-ignore - date-fns types
import { intervalToDuration, format } from 'date-fns';
import { capitalize } from 'lodash';
import React from 'react';
import Breadcrumb from 'components/App/AppShell/components/Breadcrumb';
import { FullProduct, Product } from '../Applications/Hooks/useApplication';

export const getDuration = (startDate: string, endDate: string | undefined) => {
  if (!startDate || !endDate) return {};

  const duration = intervalToDuration({
    start: new Date(startDate),
    end: new Date(endDate)
  });
  return duration;
};

export const formatDate = (date: string | undefined) => {
  if (!date) return '';
  return format(new Date(date), 'MMM dd, yyyy hh:mma');
};

export const parseWorkType = (workType: string) => {
  if (!workType || typeof workType !== 'string') return '';

  return workType
    .split('_')
    .map(word => capitalize(word))
    .join(' ');
};

export const buildLandingPage = (
  children: React.ReactNode,
  {
    breadcrumbItems
  }: { breadcrumbItems: { title: string; value: string; isLast: boolean }[] }
) => {
  return (
    <div className="flex flex-col h-full w-full">
      <Breadcrumb
        hideOrganizationDropdown={false}
        hideCropSeasonDropdown={false}
      >
        {breadcrumbItems.map(item => (
          <Breadcrumb.Item
            key={item.title}
            title={item.title}
            value={item.value}
            isLast={item.isLast}
          />
        ))}
      </Breadcrumb>
      {children}
    </div>
  );
};

export const getTargetPests = (
  product: Product,
  productsWithTargetPests: FullProduct[]
) => {
  if (!product.targetPestNameIds || product.targetPestNameIds.length === 0) {
    return undefined;
  }

  return productsWithTargetPests.find(p => {
    const pestIds = p.targetPests?.map(tp => tp.pestNameId) ?? [];
    return product.targetPestNameIds?.every(id => pestIds.includes(id));
  })?.targetPests;
};
